<template>
  <div class="week-by-car-num">
    <div class="wrapper">
      <div style="font-weight: bold">本省下辖地区加能站停靠统计</div>
<!--      <exportDate v-if="showExport" @hideExport="showExport = false" :moduleName="moduleName"/>-->
<!--      :provinCode="provinceCode"-->
      <dimension-dialog v-if="showExport" @hideExport="showExport = false" :params="params" :moduleName="moduleName" :autoChunkMonth="true"/>
      <div class="header">
        <el-form :inline="true">
          <el-form-item label="统计月份">
            <dimension-popover
                ref="objDimensionPopover"
                :isMapValue="true"
                :dimObj="dimObj"
                :change="changeDimension"
                :showBottomButton="false"
                :isItemBindClick="true"
            />
          </el-form-item>
          <el-form-item label="省市区" label-width="75px">
            <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
            <!--                :props="{ label: 'provinceName', value: 'provinceCode', children: 'cityItem',checkStrictly: true }"-->

            <el-cascader
                v-if="areaListPr.length>0"
                :options="areaListPr"
                v-model="formData.provCityCounty"
                :props="propsData()"
                collapse-tags
                filterable
                :before-filter="filterMethod"
                clearable></el-cascader>
          </el-form-item>
          <el-form-item label="站点类型" label-width="75px">
            <el-select v-model="formData.zhanDianType" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in zhanDianOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <template v-if="value1">
          <el-form-item label="吨位区间" label-width="75px">
            <el-select v-model="formData.dunwei" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in dunWeiOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="燃料类型" label-width="75px">
            <el-select v-model="formData.ranliaoType" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in ranliaoOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          </template>
          <el-button style="margin-left:30px;" @click="onDebounceSearch" class="searchBtn">查询</el-button>
          <el-button v-show="hideExport" style="margin-left:10px;" @click="exportData">导出查询结果</el-button>
          <el-button v-show="hideExport" style="margin-left:10px;" @click="exFun">导出全部明细</el-button>
          <el-button v-if="isShowBack" style="margin-left:10px;" @click="$router.push({
          path:'carStopBrand'
          })">返回上级
          </el-button>
          <el-switch
              v-model="value1"
              style="margin-left: 10px"
              @change="changeSearch"
              active-text="展开"
              inactive-text="收起">
          </el-switch>
        </el-form>
      </div>
      <el-table ref="singleTable" :data="tableData" :max-height="tableHeight1" stripe style="width: 100%">
<!--        <el-table-column type="index" fixed label="序号" align="center" width="50" fixed="left"/>-->
        <el-table-column prop="provname" label="省份" align="center" fixed="left"></el-table-column>
        <el-table-column prop="cityname" label="城市" align="center" fixed="left"></el-table-column>
        <el-table-column prop="adminname" label="区县" align="center" fixed="left"></el-table-column>
        <el-table-column prop="stopCount" label="全部油站停靠次数(次)" min-width="220" align="center"></el-table-column>
        <el-table-column prop="sinopecStopCount" label="S级油站停靠次数(次)" min-width="220" align="center"></el-table-column>
        <el-table-column prop="sinopecStopCountRate" label="S级油站停靠占比" min-width="220" align="center"></el-table-column>
        <el-table-column prop="petrochinaStopCount" label="C级油站停靠次数(次)" min-width="220" align="center"></el-table-column>
        <el-table-column prop="petrochinaStopCountRate" label="C级油站停靠占比" min-width="220" align="center"></el-table-column>
        <el-table-column prop="otherStopCount" label="E级油站停靠次数(次)" min-width="220" align="center"></el-table-column>
        <el-table-column prop="otherStopCountRate" label="E级油站停靠占比" min-width="220" align="center"></el-table-column>
        <el-table-column label="" min-width="120" fixed="right" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.provname!='合计'" style="color:#1137FF;cursor: pointer;" @click="nengDetail(scope.row)">加能站明细</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBlock">
        <el-pagination @current-change="onChangePage" :current-page.sync="index" :page-size="pageSize"
                       layout="prev, pager, next, jumper" :total="total" style="margin:auto;"></el-pagination>
      </div>
    </div>
    <div class="bottom-top">
      <h4>
        <img src="../../../assets/images/title.png"/>
        <span>说明</span>
      </h4>

      <div>1.省市区：可逐级选择，或输入关键词模糊搜索。筛选项支持多选。</div>
      <div>2.站点类型：①加油站：仅支持加油；②加气站：仅支持加气；③加氢站：仅支持加氢；④加油加气站：同时支持加油和加气。筛选项支持多选。</div>
      <div>3.吨位区间：以车辆总质量的吨位数进行区间划分。筛选项支持多选。</div>
      <div>4.燃料类型：根据车辆燃料类型进行划分。筛选项支持多选。</div>
      <div>5.停靠次数：统计区域加能站车辆停靠次数。【注】一辆车在同个加能站一天停靠多次计为一次；停靠统计时长范围为3分钟-2小时。</div>
      <div>6.停靠占比：不同站点品牌停靠次数÷全部油站停靠次数。</div>
      <div>7.统计频率：按月统计，每月6日更新上月数据。</div>
      <div>8.下一级页面：点击“加能站明细”进入对应页面。</div>

    </div>
  </div>
</template>
<script>
import http from '@/api/freight.js' //请求汇总
import _ from 'lodash'
// import areaList from './components/areaList'
import detailCard from '@/components/detailCard.vue'
import WeekPopover from '../../freight/weekByCarNum/components/weekPopover.vue'
import WeekDialog from '../../freight/weekByCarNum/components/weekDialog.vue'
import Util from '@/utils/util'
import devLog from "components/devLog.vue";
import seeTopFive from "components/seeTopFive.vue";
import {hideExport, mergeTree} from "utils/tools";
import dimensionDialog from "components/exportDate/daphne/dialog.vue";
import dimensionPopover from "components/exportDate/daphne/popover.vue";
import Cookies from "js-cookie";
import {exportCountySimplify, progress} from "api/log";
import get from 'lodash/get';
import set from 'lodash/set';
import each from 'lodash/each';

export default {
  name: 'week-by-car-num',
  components: {dimensionDialog, dimensionPopover, seeTopFive, devLog, WeekPopover, WeekDialog, detailCard},
  data() {
    let value4 = Util.lastTime(new Date())
    let arr = value4.split('-')
    let dimObj = {
      year: '',
      month: '',
      type: '0'
    }
    return {
      value1:true,
      moduleName: 'oilStationBerthCountyV2',
      hideExport: hideExport,
      showExport: false, //控制批量导出
      tableHeight1: this.tableHeight,
      nrData: {},
      isShowBack: true,
      dimObj, // 纬度对象
      ranliaoOption:Util.ranLiaoOption,
      dunWeiOption: Util.dunWeiOption,
      zhanDianOption:Util.zhanDianOption,
      formData: {
        time: '',
        dunwei:[],
        ranliaoType:[],
        zhanDianType:[],
        zhanDianBrand:[],
        provCityCounty:[]
      },
      params:{},
      tableCol: [
        {
          name: '运营车辆数',
          children: [
            {name: '全部车辆', prop: 'runCarNum0'},
            {name: '柴油车辆', prop: 'runCarNum1'},
            {name: 'LNG车辆', prop: 'runCarNum2'},
            {name: '新能源车辆', prop: 'runCarNum3'},
          ],
        },
        {
          name: '运营里程',
          children: [
            {name: '全部车辆', prop: 'totalMile0'},
            {name: '柴油车辆', prop: 'totalMile1'},
            {name: 'LNG车辆', prop: 'totalMile2'},
            {name: '新能源车辆', prop: 'totalMile3'},
          ],
        },
      ],

      curDate: '',
      tableData: [],
      onDebounceSearch: _.debounce(this.onSearch, 500),
      total: 0, // 总页数
      index: 1, // 当前页数
      pageSize: 20,
      areaListPr: []
    }
  },
  async mounted() {
    if (Cookies.get('userType') == '2') {
      this.isShowBack = false
    }
    if (this.$route.query.provCode){
      await this.getPrInter()
      this.formData.provCityCounty = [[this.$route.query.provCode]]
    }else{
      await this.getPrInter()
      this.showValue()
      this.formData.provCityCounty = this.$route.query.saveprovCityCounty||[]
    }
    // this.formData.provCityCounty=this.$route.query.provCode?this.formData.provCityCounty.push(this.$route.query.provCode):this.$route.query.provCityCounty
    // console.log( this.$route.query.provCode)
    // console.log( this.formData.provCityCounty)
    if(this.$route.query.year && this.$route.query.month){
       this.dimObj.year = this.$route.query.year
       this.dimObj.month = this.$route.query.month
       this.dimObj.type = this.$route.query.type
       this.formData.time=this.$route.query.year+''+this.$route.query.month
    } else {
      // 初始化formData.time以保持兼容性
      this.formData.time = this.dimObj.year + this.dimObj.month
    }
    this.getData(1)
  },
  methods: {
    changeDimension(e) {
      if (e.isOk) {
        let type = e.type
        this.dimObj.year = e.year
        this.dimObj.month = e.month
        this.dimObj.type = type
        // 更新formData.time以保持兼容性
        this.formData.time = e.year + e.month
      }
    },
    exportData() {
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      reqId += new Date() * 1
      let times
      times = setInterval(function () {
        progress({reqId}).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            clearInterval(times)
            that.progressNum = 100
            setTimeout(function () {
              that.mark = false
              that.progressNum = 0
            }, 500);
          }
        })
      }, 200)
      // 处理多选省市区数据，根据长度决定参数级别
      let provCodes = []
      let cityCodes = []
      let countyCodes = []

      if (this.formData.provCityCounty && this.formData.provCityCounty.length > 0) {
        this.formData.provCityCounty.forEach(item => {
          if (item && item.length > 0) {
            // 根据长度决定放到哪个级别，只添加最后一项
            if (item.length === 1) {
              provCodes.push(item[0])
            } else if (item.length === 2) {
              cityCodes.push(item[1])
            } else if (item.length === 3) {
              countyCodes.push(item[2])
            }
          }
        })
      }
      let dateType = get(this, 'dimObj.type', '0')
      window.location.assign(
          exportCountySimplify({
            reqId,
            dateType,
            year:this.formData.time.substring(0,4),
            month:this.formData.time.substring(4,6),
            stationTypes:this.formData.zhanDianType,
            tonnages:this.formData.dunwei,
            fuelTypes:this.formData.ranliaoType,
            provCodes: provCodes,
            cityCodes: cityCodes,
            countyCodes: countyCodes,
          })
      )
    },
    showValue() {
      this.regionId = this.$route.query.saveprovCityCounty
      if (this.regionId && this.regionId.length > 0) {
        // 处理多选数据，如果是单个选择项，转换为二维数组
        if (Array.isArray(this.regionId[0])) {
          // 已经是二维数组
          this.formData.provCityCounty = this.regionId
        } else {
          // 一维数组，转换为二维数组
          this.formData.provCityCounty = [this.regionId]
        }
      }
      Promise.all(this.areaListPr.map(async item => {
        if (this.regionId && item.value == this.regionId[0]) {
          let children = await this.getCiInter(item.value)
          item.children = children
          await Promise.all(item.children.map(async childrenItem => {
            if (this.regionId.length > 1 && childrenItem.value == this.regionId[1]) {
              let subChildren = await this.getCuInter(childrenItem.value)
              childrenItem.children = subChildren
            }
            return childrenItem
          }))
        }
        return item
      })).then((data) => {
        this.areaListPr = data
      })
    },
    nengDetail(row){
      console.log(this.formData.provCityCounty)
      let code = row.provcode
      // 处理多选数据，将当前选中的省市区信息传递给下一个页面
      let provCityCounty = code == '110000' || code == '120000' || code == '500000' || code == '310000' || code == '900000'?[row.provcode,row.citycode]:[row.provcode,row.citycode,row.admincode]
      this.$router.push({
        path: 'carPriviceBrandPetrified',
        query: {
          // cityCode: row.provinceCode,
          // cityName: row.provinceName,
          // year: row.year,
          // month: row.month,
          year:this.formData.time.substring(0,4),
          month:this.formData.time.substring(4,6),
          provCityCounty: provCityCounty,
          saveprovCityCounty:this.formData.provCityCounty,
          type:this.dimObj.type
        }
      })
    },
    closeProAll(curr) {
      this[curr] = false
    },
    seeDevLog(row) {
      this.devLogIs = true
      this.currRow = row
    },
    seeTopFive(row) {
      this.seeTopFiveIs = true
      this.currRow = row
    },
    changeSearch() {
      if (this.value1) {
        this.tableHeight1 = this.tableHeight - 60
      } else {
        this.tableHeight1 = this.tableHeight
      }
    },
    filterMethod(value) {
      return http
          .getCountyAreaListBySearch({keyword: value})
          .then(({data}) => {
            if (data.length !== 0) {
              const oldList = this.areaListPr || []
              const newList = data || []
              this.areaListPr = mergeTree(oldList, newList)
              return true // 允许 filter
            }
            return false // 阻止 filter
          })
    },
    async getPrInter() {
      http
          .getCountyAreaListBySearch({keyword:''})
          .then(({data}) => {
            this.areaListPr = data
          })
    },
    getCiInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'CITY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: code == '110000' || code == '120000' || code == '500000' || code == '310000' || code == '900000' ? true : false
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    getCuInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'COUNTY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    propsData() {
      const vm = this
      return {
        lazy: false,
        multiple:true,
        checkStrictly: true,
        expandTrigger: 'hover',
        async lazyLoad(node, resolve) {
          const {level, value} = node;
          if (level === 1) {
            resolve(await vm.getCiInter(value, level));
          } else if (level === 2) {
            resolve(await vm.getCuInter(value, level));
          } else {
            resolve([])
          }
        }
      }
    },
    getListP(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, areaType: 'COUNTY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }));
        resolve(nodes);
      })
    },
    toDetail(row) {
      this.isShowMes = true
      this.nrData = row
    },
    changeDetail() {
      this.isShowMes = false
    },
    onChangePage(index) {
      this.index = index
      this.getData(2)
    },
    onSearch() {
      this.index = 1
      this.total = 0
      this.getData(2)
    },
    exFun(){
      // 处理多选省市区数据，根据长度决定参数级别
      let provCodes = []
      let cityCodes = []
      let countyCodes = []

      if (this.formData.provCityCounty && this.formData.provCityCounty.length > 0) {
        this.formData.provCityCounty.forEach(item => {
          if (item && item.length > 0) {
            // 根据长度决定放到哪个级别，只添加最后一项
            if (item.length === 1) {
              provCodes.push(item[0])
            } else if (item.length === 2) {
              cityCodes.push(item[1])
            } else if (item.length === 3) {
              countyCodes.push(item[2])
            }
          }
        })
      }

      let dateType = get(this, 'dimObj.type', '0')
      this.params={
        dateType,
        year: this.dimObj.year || "",
        month: this.dimObj.month || "",
        stationType:this.formData.zhanDianType,
        tonnage:this.formData.dunwei,
        fuelType:this.formData.ranliaoType,

        provCodes: provCodes,
        cityCodes: cityCodes,
        countyCodes: countyCodes,
      }
      this.showExport = true
    },
    getData(num = 2) {
      if (num == 2 && (!this.dimObj.year && !this.dimObj.month)) {
        this.$message({
          message: '请选择月份',
          type: 'warning',
        })
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      console.log(this.formData.provCityCounty)

      // 处理多选省市区数据，根据长度决定参数级别
      let provCodes = []
      let cityCodes = []
      let countyCodes = []

      if (this.formData.provCityCounty && this.formData.provCityCounty.length > 0) {
        this.formData.provCityCounty.forEach(item => {
          if (item && item.length > 0) {
            // 根据长度决定放到哪个级别，只添加最后一项
            if (item.length === 1) {
              provCodes.push(item[0])
            } else if (item.length === 2) {
              cityCodes.push(item[1])
            } else if (item.length === 3) {
              countyCodes.push(item[2])
            }
          }
        })
      }

      let dateType = get(this, 'dimObj.type', '0')
      const params = {
        dateType,
        pageNum: this.index,
        pageSize: this.pageSize,
        year: this.dimObj.year || "",
        month: this.dimObj.month || "",
        stationTypes:this.formData.zhanDianType,
        tonnages:this.formData.dunwei,
        fuelTypes:this.formData.ranliaoType,

        provCodes: provCodes,
        cityCodes: cityCodes,
        countyCodes: countyCodes,
      }

      http
          .countyStatistics(params)
          .then((e) => {
            loading.close();
            if (200 != e.code) {
              this.$message({
                message: e.message || '数据获取出错',
                type: 'error',
              })
              return
            }

            if (e.data.length == 0) {
              this.tableData = []
              return;
            }
            if (e.data.year && e.data.month) {
              this.dimObj.year = e.data.year
              this.dimObj.month = e.data.month
              this.formData.time = e.data.year + "" + e.data.month
              // 更新dimension-popover的显示值
              if (this.$refs.objDimensionPopover) {
                this.$refs.objDimensionPopover.setCtrlValue()
              }
            }

            this.tableData = e.data.dataList.map((_) => {
              // _.decryptedCompanyName = false
              // _.companyCreditCodeIs = false
              // _.cmpnanyDevStartTime = _.devStartTime != '-' ? Util.format(new Date(_.devStartTime * 1).getTime(), "yyyy-MM-dd") : '-'
              // _.cmpnanyDevEndTime = _.devEndTime != '-' ? Util.format(new Date(_.devEndTime * 1).getTime(), "yyyy-MM-dd") : '-'
              // _.companyCardStatusText = this.getNmae(Util.companyCardStatusOption, _.companyCardStatus)
              // _.companyDevStatusText = this.getNmae(Util.devStatusOption, _.devStatus)
              // _.cardTypeText = this.getNmae(Util.cardTypeOption, _.cardType)
              // _.reachStatusText = this.getNmae(Util.reachStatusOptions, _.reachStatus)
              console.log(_)
              return _
            })
            this.total = e.data.total
            this.index = e.data.pageNum
          })
          .catch((err) => {
            console.error(err)
            this.curDate = ''
            loading.close();
          })
    },
    getNmae(allData, val) {
      let curr = allData.filter(item => {
        return item.value == val
      })
      if (curr.length > 0) {
        return curr[0].label
      } else {
        return '-'
      }
    },
    onWeekPopOverCommand(params) {
      switch (params.type) {
        case 'default-week':
          this.getData()
          break
        default:
          break
      }
    },

    onWeekDialogCommand(params) {
      switch (params.type) {
        case 'ok':
          window.location.assign(http.getWeekCarOperateExport(params.data))
          this.showWeekDialog = false
          break
        case 'close':
          this.showWeekDialog = false
          break
        default:
          break
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.proTextSty{
  font-size: 14px;
}
.tableTitleSty{
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  margin-top: 10px;
}
.searchBtn {
  background: #41B883;
  color: #ffffff;
}

.wrapper {
  padding: 20px;
  background: #fff;

  .header {
    //margin-bottom: 20px;
    margin-top: 20px;
  }
}

/deep/ .el-table__empty-block {
  width: 100% !important;
}

/deep/ .el-form--inline .el-form-item {
  margin-right: 32px;
}

.pageBlock {
  display: flex;
  margin-top: 20px;
}
</style>
<style lang="stylus">
.el-cascader-menu {
  overflow: hidden;
}
</style>
